module.exports = __webpack_public_path__ + "media/images/pack-03-887e56306668a037249cf1c16d4603a7.webp";